
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { WeddingEvent, WeddingEventImage, WeddingEventImageComment } from 'ignite360-core';
import { S3_BUCKET, S3_REGION } from '@/api';
import LikeButton from './LikeButton.vue';
import CommentButton from './CommentButton.vue';
import ShareButton from './ShareButton.vue';
import Comment from './Comment.vue';
import { WeddingEventImageCaptionSettings, WeddingEventImageCommentSettings } from '@/types';
import WeddingEventImageCommentForm from './WeddingEventImageCommentForm.vue';
import WeddingEventImageCaptionForm from './WeddingEventImageCaptionForm.vue';
import { isMobile } from '@/utilities';
@Component({
  name: 'image-view',
  components: {
    LikeButton,
    CommentButton,
    ShareButton,
    Comment,
    WeddingEventImageCommentForm,
    WeddingEventImageCaptionForm,
  },
})
export default class ImageView extends Vue {
  @Prop({ required: true }) image!: WeddingEventImage;

  @Prop({ required: true }) event!: WeddingEvent;

  @Prop({ required: false, default: false }) isAdmin!: boolean;

  isPublic = false;
  commentForm: WeddingEventImageCommentSettings = {
    name: localStorage.getItem('wedding-event-image-comment-name') || '',
    comment: '',
  };

  captionForm: WeddingEventImageCaptionSettings = {
    title: '',
  };

  openedComments = false;

  editCaptionMode = false;
  isVideoPlaying = false;

  private lastTap = 0;
  private DOUBLE_TAP_DELAY = 300; // milliseconds

  mounted() {
    if (this.isVideo(this.image)) {
      const videoElement = this.$el.querySelector('video');
      if (videoElement) {
        videoElement.addEventListener('play', () => (this.isVideoPlaying = true));
        videoElement.addEventListener('pause', () => (this.isVideoPlaying = false));
        videoElement.addEventListener('ended', () => (this.isVideoPlaying = false));
      }
    }
  }

  get userSessionId(): string {
    return localStorage.getItem('userSessionId') || '';
  }

  startVideoPlayback() {
    const videoElement = this.$el.querySelector('video');
    if (videoElement) {
      videoElement.play();
    }
  }

  openComments() {
    this.openedComments = !this.openedComments;
  }

  get isCommentFormOpen(): boolean {
    return this.openedComments || !isMobile();
  }

  imageUrl(image: WeddingEventImage) {
    return `https://${S3_BUCKET}.s3.${S3_REGION}.amazonaws.com/bots/${
      this.event!.bot.id
    }/wedding/events/${this.event!.id}/images/${image.id}.${image.extension}`;
  }

  isVideo(image: WeddingEventImage) {
    return (
      image.extension === 'mp4' ||
      image.extension === 'mov' ||
      image.extension === 'avi' ||
      image.extension === 'webm'
    );
  }

  handleTouchStart(event: TouchEvent) {
    const currentTime = new Date().getTime();
    const tapLength = currentTime - this.lastTap;

    if (tapLength < this.DOUBLE_TAP_DELAY && tapLength > 0) {
      event.preventDefault();
      this.$emit('toggle-like', this.image);
    }
    this.lastTap = currentTime;
  }
  get sortedComments(): WeddingEventImageComment[] {
    return (
      this.image.comments?.sort(
        (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
      ) || []
    );
  }

  submitComment(commentForm: WeddingEventImageCommentSettings) {
    this.$emit('submit-comment', commentForm);
    this.commentForm = { name: commentForm.name, comment: '' };
  }

  submitCaption(captionForm: WeddingEventImageCaptionSettings) {
    this.captionForm = { title: (captionForm.title || '').trim() };
    this.$emit('submit-caption', captionForm);
  }

  cancelCaption() {
    this.editCaptionMode = false;
    this.captionForm = { title: this.image?.title || '' };
  }

  get canUpdateCaption(): boolean {
    return this.image?.userSessionId === this.userSessionId || this.isAdmin;
  }

  get canComment(): boolean {
    return this.event.configAllowImageComments;
  }

  get canDeleteImage(): boolean {
    return this.image?.userSessionId === this.userSessionId || this.isAdmin;
  }

  @Watch('image', { immediate: true })
  onImageChange() {
    this.commentForm.name = localStorage.getItem('wedding-event-image-comment-name') || '';
    this.captionForm.title = this.image?.title || '';
    this.editCaptionMode = false;
  }
}
